// @ts-nocheck

import { callNative, requestTypes } from '../../lib/bridge';

type QRPluginType = {
  isAvailable: () => Promise<boolean>;
  requestCameraPermission: () => Promise<boolean>;
};

const isAvailable = async (): Promise<boolean> => {
  try {
    const result = await callNative(requestTypes.QR_IS_AVAILABLE);

    return result?.data ?? false;
  } catch (e) {
    console.log('QRPlugin plugin not available');
  }

  return false;
};

const requestCameraPermission = async (): Promise<boolean> => {
  try {
    const result = await callNative(requestTypes.REQUEST_CAMERA_PERMISSION);

    return result?.data ?? false;
  } catch (e) {
    console.log('QRPlugin plugin not available');
  }

  return false;
};

const QRPlugin: QRPluginType = Object.freeze({
  isAvailable,
  requestCameraPermission,
});

export default QRPlugin;
